import { useState, useEffect, useContext,useRef } from "react";
import Select from "react-select";
import { debounce } from "lodash";

import { pathMaker } from "../../../../utils/helperFunctions";
import useAxios from "../../../../services/useAxios.tsx";
import Authentication from "../../../../context/Authentication/AuthenticationContext.ts";

const formatOptionLabel = ({ value, label, productImage }) => (
  <div className="d-flex align-items-center">
    <img
      src={pathMaker(productImage)}
      className="wh-100 mr-x-6 rounded-5"
      style={{ objectFit: "cover" }}
    />
    <div>{label}</div>
  </div>
);

export default function SimilarProducts({ selectSimilar, setSelectSimilar }) {
  const auth = useContext(Authentication);

  const { execute: filterProductsApi } = useAxios("api3/filterproducts");
  // const [selectSimilar,setSelectSimilar]=useState([]);
  const [products, setProducts] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [pageCount, setPageCount] = useState({ page: 1, count: 40 });
  const [totalProduct, setTotalProduct] = useState("");

  const getProductFunc = (title) => {
    let payload = {
      page: pageCount.page,
      count: pageCount.count,
      ...(auth?.userInfo?.userType == "0" && { all: "1" }),
    };
    if (title != "") {
      payload = { ...payload, title: title };
      setProductSearch(title);
    }
    filterProductsApi(payload).then((data) => {
      setProducts(
        data.products.map((v) => ({
          //   ...v,
          value: v.id,
          label: v.title,
          productImage: v?.file,
        }))
      );
      setTotalProduct(data.total);
    });
  };

  const onScrollSelect = () => {
    if (totalProduct > products.length) {
      filterProductsApi({
        title: productSearch,
        page: pageCount.page + 1,
        count: pageCount.count,
        ...(auth.userInfo.userType == "0" && { all: 1 }),
      }).then((data) => {
        setPageCount((prev) => ({ ...prev, page: +prev.page + 1 }));
        setTotalProduct(data?.total);
        let x = [
          ...data?.products?.map((v) => ({
            label: v.title,
            productImage: v?.file,
            value: v.id,
          })),
        ];
        let arr = [...products, ...x];
        setProducts(arr);
      });
    }
  };

  const productDebounce = useRef(debounce(getProductFunc, 1000));

  useEffect(() => {
    getProductFunc("");
  }, []);

  return (
    <>
      <div className="mr-x-20 mr-t-30">
        <Select
          options={products}
          value={selectSimilar}
          isMulti={true}
          placeholder="محصولات مشابه را انتخاب نمایید"
          formatOptionLabel={formatOptionLabel}
          onChange={(e) => {
            setSelectSimilar(e);
          }}
          onInputChange={(e) => {
            productDebounce.current(e, 1);
            setPageCount((prev) => ({ ...prev, page: 1 }));
            // setProductSearch(e);
          }}
          onMenuScrollToBottom={() => {
            onScrollSelect();
          }}
        />
      </div>
    </>
  );
}
